
export interface Environments {
    localhost: boolean,
    dev: boolean,
    uat: boolean,
    preprod: boolean,
    prod: boolean
}

export const isProdEnvironment = (): boolean => {
    const hostName: string = window.location.hostname;

    if (hostName.indexOf("localhost") > -1
        || hostName.indexOf("dev") > -1
        || hostName.indexOf("uat") > -1
        || hostName.indexOf("preprod") > -1) {
        return false;
    } else if (hostName.indexOf("listings") > -1
        && hostName.indexOf("dev") === -1
        && hostName.indexOf("uat") === -1
        && hostName.indexOf("preprod") === -1) {
        return true;
    }

    return false;
}